export default (state = [], action) => {
  switch (action.type) {
    case "CREATE_TREATMENT_CENTER":
      return [...state, action.payload.treatmentCenter];
    case "UPDATE_TREATMENT_CENTERS":
      return action.payload.treatmentCenters;
    case "DELETE_TREATMENT_CENTER":
      return state.filter((treatmentCenter) => {
        return treatmentCenter.id !== action.payload.treatmentCenter.id
      });
    default:
      return state;
  }
}
